<div class="light-toggle-group">
  <div class="light-toggle-floater" #floater></div>
  <div
    class="light-toggle-btn-container"
    role="radiogroup"
    [attr.aria-label]="groupAriaLabel || null"
  >
    <ng-content></ng-content>
  </div>
</div>
